import { create, Describe, string, type } from 'superstruct';

import { ExportStatus } from '~extension/web2print/model/Export';

export const ExportStatusFactoryValidator: Describe<ExportStatus> = type({
  error: string(),
  status: string(),
  url: string(),
});

export function makeExportStatusFactory(raw: unknown) {
  try {
    const formResponse = create(raw, ExportStatusFactoryValidator);
    return formResponse;
  } catch (err) {
    console.error(err);
  }
}
